import { makeFieldStyleSelector } from "@client/content/modules/selectors";
import { type RootContainerProps } from "@client/content/types";
import { getNoImageUrl } from "@client/lib/assets";
import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState, ScreenType } from "@client/types";
import { connect } from "react-redux";
import { localStateSelector } from "../../selectors";
import Component, { type ActionProps, type MapProps } from "./component";

type Props = RootContainerProps &
  Omit<ActionProps, "onChangeVariant"> & {
    isEstimatedTax: boolean;
  };
const makeMapStateToProps = () => {
  const fieldStyleSelector = makeFieldStyleSelector();
  const isDiscountVisibleSelector = getSettingValueSelector(TargetSelector.Entity, "discountField");

  return (state: AppState, props: Props): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      cart: localState.cart,
      hasInvalidCoupon: !!localState.invalidCoupons.length,
      fieldStyle: fieldStyleSelector(state, props),
      currencyCode: localState.currencyCode,
      isDiscountVisible: isDiscountVisibleSelector(state, props),
      isMobile: state.viewport.screen === ScreenType.Mobile,
      noImageUrl: getNoImageUrl(),
      paymentMethods: localState.cart.paymentMethods,
      productVariantId: localState.productVariantId,
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: Props): ActionProps => ({
  onApplyCoupon: props.onApplyCoupon,
  onRemoveCoupon: props.onRemoveCoupon
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
